import productInstance from '../instance'

const storeMenu = (data) => {
  return productInstance.post('/menus', data)
}

export default storeMenu
